import { render, staticRenderFns } from "./PageEffectifPortage.vue?vue&type=template&id=27161708&scoped=true&"
import script from "./PageEffectifPortage.vue?vue&type=script&lang=js&"
export * from "./PageEffectifPortage.vue?vue&type=script&lang=js&"
import style0 from "./PageEffectifPortage.vue?vue&type=style&index=0&id=27161708&scoped=true&lang=scss&"
import style1 from "./PageEffectifPortage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27161708",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27161708')) {
      api.createRecord('27161708', component.options)
    } else {
      api.reload('27161708', component.options)
    }
    module.hot.accept("./PageEffectifPortage.vue?vue&type=template&id=27161708&scoped=true&", function () {
      api.rerender('27161708', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Menus/PageEffectifPortage.vue"
export default component.exports